import { Badge, Flex, Grid, SelectField } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

import { listSpares } from "graphql/queries";

const SelectSpare = ({
  initialValues,
  onChangeSpares,
  parentName,
  parentValue,
  companyID,
  excludeSpares = [],
}) => {
  const [spareSelectedList, setSpareSelectedList] = useState([]);
  const [spares, setSpares] = useState([]);

  const onDelete = (index) => {
    setSpareSelectedList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated.splice(index, 1);
      if (onChangeSpares) onChangeSpares(listUpdated);
      return listUpdated;
    });
  };

  const onSelect = (e) => {
    const { value } = e.target;

    setSpareSelectedList((prevSt) => {
      const listUpdated = [...prevSt, value];
      if (onChangeSpares) onChangeSpares(listUpdated);
      return listUpdated;
    });
  };

  async function fetchSpares() {
    try {
      const sparesData = await API.graphql(
        graphqlOperation(listSpares, {
          filter: {
            or: [
              ...(parentValue ? [{ [parentName]: { eq: parentValue } }] : []),
              { [parentName]: { attributeExists: false } },
            ],
            companyID: { eq: companyID },
            deletedAt: { attributeExists: false },
          },
        })
      );
      const sparesItems = sparesData.data.listSpares.items;
      setSpares(sparesItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchSpares);
    }
  }

  useEffect(() => {
    setSpareSelectedList(initialValues ?? []);
  }, [initialValues]);

  useEffect(() => {
    fetchSpares();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid rowGap="15px">
      <Grid templateColumns={{ base: "1fr" }} rowGap="15px" columnGap="15px">
        <SelectField
          name="spare"
          label={strings.fields.addSpare.label}
          onChange={onSelect}
        >
          <option value="">{strings.selectOption}</option>
          {spares
            ?.filter(
              (spare) =>
                !spareSelectedList?.some((spareSel) => spareSel === spare.id) &&
                (excludeSpares
                  ? !excludeSpares?.some((ex) => ex === spare.id) ?? true
                  : true)
            )
            .map((spare) => (
              <option key={spare.id} value={spare.id}>
                {spare.name}
              </option>
            ))}
        </SelectField>
      </Grid>
      <Flex rowGap="10px" columnGap="10px" wrap="wrap">
        {spareSelectedList?.map((spareSel, index) => (
          <Badge key={index}>
            {spares?.find((spare) => spare.id === spareSel)?.name}
            &nbsp;
            <CloseIcon
              style={{ cursor: "pointer" }}
              fontSize="inherit"
              onClick={() => onDelete(index)}
            />
          </Badge>
        ))}
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    selectOption: "Seleccione una opción",
    fields: {
      addSpare: {
        label: "Agregar Repuesto",
      },
    },
    responses: {
      errorFetchSpares: "Error al consultar repuestos",
    },
  },
});

export default SelectSpare;
